// NPM
import 'whatwg-fetch';

// Hosts
const API_HOST = process.env.REACT_APP_API_HOST;

function setHeaders(token, customHeaders = {}) {
  let headers = {
    'Content-Type': 'application/json',
    ...customHeaders,
  };

  if (!!token) {
    headers['Authorization'] = `JWT ${token}`;
  }

  return headers;
}

function parseResponse(response) {
  if (response.ok) {
    return handleSuccess(response);
  } else {
    return handleErrors(response);
  }
}

function handleSuccess(response) {
  if (response.status === 204) {
    return {
      status: response.status,
      payload: {},
      errors: {},
    };
  } else {
    return response.json().then(payload => {
      return {
        status: response.status,
        payload: payload,
        errors: {},
      };
    });
  }
}

function handleErrors(response) {
  const { status, headers } = response;
  let contentType = headers.get('content-type');
  let res = {
    status,
    payload: {},
  };

  if (status === 500) {
    res.errors = {
      error: 'Something went wrong',
    };
  }

  if (contentType && contentType.includes('application/json')) {
    return response.json().then(errors => {
      return { ...res, errors };
    });
  } else {
    res.errors = { error: response.statusText };
  }
  return res;
}

function getURL(url) {
  return `${API_HOST}/${url}`;
}

function get(url, params, token) {
  let finalUrl = new URL(getURL(url));
  if (params) {
    Object.keys(params).forEach(key =>
      finalUrl.searchParams.append(key, params[key])
    );
  }
  return request('GET', finalUrl, undefined, token);
}

function post(url, body, token) {
  return request('POST', getURL(url), body, token);
}

function put(url, body, token) {
  return request('PUT', getURL(url), body, token);
}

// unfortunately 'delete' is a reserved word in JS :(
function remove(url, body, token) {
  return request('DELETE', getURL(url), body, token);
}

function request(method, url, body, token) {
  return fetch(url, {
    method: method,
    body: JSON.stringify(body),
    headers: setHeaders(token),
  }).then(parseResponse);
}

export default {
  get,
  post,
  put,
  remove,
};



// WEBPACK FOOTER //
// ./src/services/apiService.js